import {findClosestElementByClass} from "../helpers/dom/closest";
import {scrollToElement} from "../helpers/dom/scroll";

export const ecommerceApprovals = {
    checkboxStatus: false,
    allCheckboxesArr: [],
    init: function (approvalsElement) {
        const approvalContainer = document.querySelectorAll(`.${approvalsElement}`);

        if (!approvalContainer.length) return;
        
        approvalContainer.forEach(el => {
            const approvalBoxes = el.querySelectorAll('.ecommerce-approvals__approval');
            if (!approvalBoxes) return;
            const singleApproval = el.querySelectorAll('.ecommerce-approvals__approval-content');
    
            this.prepreSelectAllCheckboxes(el);  
            // this.visibilityOfApprovals(singleApproval);         
            this.hideCurrentApproval();                        
            this.prepareSelectCurrentApprovalRules(approvalBoxes);
            this.createArrOfCheckboxes(singleApproval);
            this.prepareCurrentActiveApproval();
            
            setTimeout(() => this.prepareSetLabelsPosition(), 500);
        });
    },
    prepreSelectAllCheckboxes: function (parentElem) {
        const acceptAllContainer = parentElem.querySelector('.ecommerce-approvals__group-approval');
        const acceptAllCheckboxContainer = acceptAllContainer.querySelector('.checkAll');
        const acceptAllTitle = acceptAllContainer.querySelector('.ecommerce-approvals__approval-title');
        const acceptAllLabel = acceptAllCheckboxContainer.querySelector('label');
        const acceptAllCheckbox = acceptAllCheckboxContainer.querySelector('input[type="checkbox"]');
        const buttonNext = document.querySelector('.ecommerce-approvals__link--next');
        const clickableElemsArr = [];

        const scrollToPosition = window.innerHeight / 2;

        clickableElemsArr.push(acceptAllLabel);
        clickableElemsArr.push(acceptAllTitle);

        clickableElemsArr.forEach(el => {
            el.addEventListener('click', _ => {
                if (acceptAllCheckbox.checked) this.checkboxStatus = true;
                if (!acceptAllCheckbox.checked) this.checkboxStatus = false;
                this.selectAllCheckboxes(el, this.checkboxStatus, parentElem);
                this.prepareNumberOfCheckedCheckboxes();
                scrollToElement(buttonNext, scrollToPosition, 1000);
            });
        });
    },
    selectAllCheckboxes: function (clickedElement, checkboxStatus, parentElem) {
        const singleApproval = parentElem.querySelectorAll('.ecommerce-approvals__approval')
        const allCheckboxes = parentElem.querySelectorAll('input[type="checkbox"]');
        const checkboxContainers = parentElem.querySelectorAll('.ecommerce-approvals__checkbox-container');
        const approvalsContent = parentElem.querySelectorAll('.singleRulesContainer');
        
        allCheckboxes.forEach((el, i) => {
            if (el.parentElement.classList.contains('checkAll') && clickedElement.nodeName === "LABEL") return;

            if (checkboxStatus) {
                el.checked = false;
                this.unactiveColorOfCheckboxes(checkboxContainers);
                this.hideAllApprovals(approvalsContent);
                this.visibilityOfApprovals(singleApproval);
                return;
            }

            el.checked = true;
            this.activeColorOfCheckboxes(checkboxContainers);
            this.showAllApprovals(approvalsContent);
            this.visibilityOfApprovals(singleApproval);
        });
    },
    activeColorOfCheckboxes: function (checkboxContainers) {
        checkboxContainers.forEach(el => 
            el.classList.add('ecommerce-approvals__checkbox-container--checked')
        )
    },
    unactiveColorOfCheckboxes: function (checkboxContainers) {
        checkboxContainers.forEach(el => 
            el.classList.remove('ecommerce-approvals__checkbox-container--checked')
        )
    },
    showAllApprovals: function (approvalsContent) {
        approvalsContent.forEach(el => el.style.display = 'block')
    },
    hideAllApprovals: function (approvalsContent) {
        approvalsContent.forEach(el => el.style.display = 'none')
    },
    visibilityOfApprovals: function (singleApproval) {
        singleApproval.forEach(el => {
            const showHideLabel = el.querySelector('.ecommerce-approvals__open-label');
            const apprContent = el.querySelector('.singleRulesContainer');

            if (apprContent.style.display === 'none') showHideLabel.innerText = 'ROZWIŃ';
            if (apprContent.style.display === 'block') showHideLabel.innerText = 'ZWIŃ';
        });
    },
    hideCurrentApproval: function () {
        const showHideLabels = document.querySelectorAll('.ecommerce-approvals__open-label');

        showHideLabels.forEach(el => {
            el.addEventListener('click', _ => {
                const parent = findClosestElementByClass(el, 'ecommerce-approvals__approval-content');
                const apprContent = parent.querySelector('.singleRulesContainer');

                if (!apprContent.offsetHeight) {
                    apprContent.style.display = 'block';
                    el.innerText = 'ZWIŃ';
                    return;
                }

                if (apprContent.offsetHeight > 0) {
                    apprContent.style.display = 'none';
                    el.innerText = 'ROZWIŃ';
                }
            });
        });
    },
    prepareSelectCurrentApprovalRules: function (singleApproval) {
        singleApproval.forEach(el => {
            const approvalTitle = el.querySelector('.ecommerce-approvals__approval-title');
            const labelContainer = el.querySelector('.ecommerce-approvals__checkbox-container');
            const approvalLabel = labelContainer.querySelector('label');
            const currApprClickableElmsArr = [];

            currApprClickableElmsArr.push(approvalLabel);
            currApprClickableElmsArr.push(approvalTitle);

            currApprClickableElmsArr.forEach(el => {
                el.addEventListener('click', _ => {
                    const parent = findClosestElementByClass(el, 'ecommerce-approvals__approval');
                    this.conditionsCurrentApprovalRules(parent, el);
                    this.prepareNumberOfCheckedCheckboxes();
                    this.checkIfElemIsChecked(this.allCheckboxesArr);
                });
            });
        });
    },
    conditionsCurrentApprovalRules: function (parentElem, currentElem) {
        const checkboxContainer = parentElem.querySelectorAll('.ecommerce-approvals__checkbox-container');
        const checkbox = parentElem.querySelector('input[type="checkbox"]');
        const approvalContent = parentElem.querySelectorAll('.singleRulesContainer');
        const allRules = approvalContent[0].querySelectorAll('input[type="checkbox"]');
        let parElemsArr = []; 

        parElemsArr.push(parentElem);

        if (!checkbox.checked) {
            if (currentElem.nodeName === "SPAN") checkbox.checked = true;
            this.activeColorOfCheckboxes(checkboxContainer);
            this.showAllApprovals(approvalContent);
            this.visibilityOfApprovals(parElemsArr);
            this.selectCurrentApprovalRules(allRules, true);
            return;
        };
        if (currentElem.nodeName === "SPAN") checkbox.checked = false;
        this.unactiveColorOfCheckboxes(checkboxContainer);
        this.hideAllApprovals(approvalContent);
        this.visibilityOfApprovals(parElemsArr);
        this.selectCurrentApprovalRules(allRules, false);
    },
    selectCurrentApprovalRules: function (singleRule, selectCondition) {
        singleRule.forEach(el => {
            if (selectCondition) {
                el.checked = true;
                return;
            } 
            el.checked = false;
        })
    },
    prepareNumberOfCheckedCheckboxes: function () {
        this.allCheckboxesArr.forEach(el => {
            el.addEventListener('change', _ => 
                this.checkIfElemIsChecked(this.allCheckboxesArr)
            );
        });
    },
    createArrOfCheckboxes: function (singleApproval) {
        singleApproval.forEach(el => {
            const allCheckboxes = el.querySelectorAll('input[type="checkbox"]');

            allCheckboxes.forEach(el => this.allCheckboxesArr.push(el));
        });
    },
    checkIfElemIsChecked: function (allCheckboxesArr) {
        const acceptAllContainer = document.querySelector('.ecommerce-approvals__group-approval');
        const acceptAllCheckboxContainer = acceptAllContainer.querySelector('.checkAll');
        const acceptAllCheckbox = acceptAllCheckboxContainer.querySelector('input[type="checkbox"]');
        let uncheckedElems = 0;

        allCheckboxesArr.forEach(el => {
            if (!el.checked) uncheckedElems++;
        });

        if (!uncheckedElems) {
            acceptAllCheckboxContainer.classList.add('ecommerce-approvals__checkbox-container--checked');
            acceptAllCheckbox.checked = true;
            return;
        }

        acceptAllCheckboxContainer.classList.remove('ecommerce-approvals__checkbox-container--checked');
        acceptAllCheckbox.checked = false;
    },
    prepareCurrentActiveApproval: function () {
        const approvalsContainer = document.querySelector('.ecommerce-approvals');
        const singleApproval = approvalsContainer.querySelectorAll('.ecommerce-approvals__approval');

        singleApproval.forEach(el => {
            const checkboxesParent = el.querySelector('.singleRulesContainer');
            const currentApprovalCheckboxes = checkboxesParent.querySelectorAll('input[type="checkbox"]');
            const groupedCheckboxParent = el.querySelector('.ecommerce-approvals__checkbox-container');
            const groupedCheckbox = groupedCheckboxParent.querySelector('input[type="checkbox"]');

            const elements = {
                currentApprovalCheckboxes: currentApprovalCheckboxes,
                groupedCheckboxParent: groupedCheckboxParent,
                groupedCheckbox: groupedCheckbox
            }

            this.currentActiveApproval(el, elements);
        });
    },
    currentActiveApproval: function (parentElem, elements) {
        elements.currentApprovalCheckboxes.forEach(el => {
            el.addEventListener('change', _ => 
                this.singleApprovalCheckedCheckoxes(elements)
            );
        })
    },
    singleApprovalCheckedCheckoxes: function (elements) {
        let numberOfNotCheckedElems = 0;
        elements.currentApprovalCheckboxes.forEach(el => {
            if (!el.checked) numberOfNotCheckedElems++;
        })

        if (numberOfNotCheckedElems) {
            elements.groupedCheckboxParent.classList.remove('ecommerce-approvals__checkbox-container--checked');
            elements.groupedCheckbox.checked = false;
            return;
        }

        elements.groupedCheckboxParent.classList.add('ecommerce-approvals__checkbox-container--checked');
        elements.groupedCheckbox.checked = true;
    },
    prepareSetLabelsPosition: function () {
        const approvals = document.querySelectorAll('.ecommerce-approvals__approval');
        approvals.forEach((el, i) => {
            const labelContainer = el.querySelector('.ecommerce-approvals__checkbox-container');
            const label = labelContainer.querySelector('label');
            const contentWrapper = el.querySelector('.approvalContent');
            const contentWrapperHeight = contentWrapper.offsetHeight;
            const labelPos = (contentWrapperHeight / 2) - 10;
            if (window.innerWidth >= 768) {
                label.style.position = 'absolute';
                label.style.top = `${labelPos}px`;
                label.style.left = '50%';
                label.style.transform = 'translateX(-50%)';
                labelContainer.style.padding = "32px 27px";
                return;
            }
            label.style.position = 'relative';
            label.style.top = 'auto';
            label.style.left = 'auto';
            label.style.transform = 'none';
            labelContainer.style.padding = '12px 17px';
        })
    }
}